import DroppedPinIcon from "../components/DroppedPinIcon";
import FreeIcon from "../components/FreeIcon";
import Logo from "../components/Logo";
import ShieldElectricIcon from "../components/ShieldElectricIcon";
import Spec from "../components/Spec";
import EventCountdown from "../components/EventCountdown";
import EventDate from "../components/EventDate";
import Hero from "../components/Hero";
import Organizers from "../components/Organizers";
import ImageCarousel from "../components/ImageCarousel";
import VideoSection from "../sections/VideoSection";
import ButtonLink from "../components/ButtonLink";
import eventFormatPhoto from "../assets/spiderman.jpeg";
import post_logo from "../assets/spcs_logo.svg"
import video_image from "../assets/house_of_startups.jpg"

//import PlanningSection from "../sections/PlanningSection";
import Agenda from "../components/Agenda";
import ThankYouNote from "../components/ThankYouNote";
import SpeakerSection from "../sections/SpeakerSection";
import speaker_marcel_zumbuehl from "../assets/speakers/marcel-zumbuehl.png";
import speaker_guillaume_vassault from "../assets/speakers/guillaume-vassault-houliere.jpg";
import speaker_ralph_el_khoury from "../assets/speakers/El-Khoury_Ralph.jpg"
import speaker_antony_ancelin from "../assets/speakers/Ancelin_Antony.jpg";
import speaker_nicolas_aunay from "../assets/speakers/Aunay_Nicolas.jpg";
import speaker_sander_hofman from "../assets/speakers/Hofman_Sander.jpg";



import Sponsors from "../components/Sponsors";
import harfanglab_logo from "../assets/sponsors/harfanglab.png"
import elastic_logo from "../assets/sponsors/elastic-logo-reverse.svg";
import tenable_logo from "../assets/sponsors/tenable-logo.png";
import vectra_logo from "../assets/sponsors/vectra-logo.png";
import ywh_logo from "../assets/sponsors/YWH_logo.png"

/*
import airlock_logo from "../assets/sponsors/airlock-logo.png";
import infomaniak from "../assets/infomaniak.png";
import pwc_outlined_logo from "../assets/pwc_outlined_logo.png";
import hkta_logo from "../assets/hkta_logo.png";
import sentinel_one from "../assets/sponsors/SentinelOne_Logo_white-purple.png";
import fortinet_logo from "../assets/sponsors/fortinet-logo.png";
import elastic_logo from "../assets/sponsors/elastic-logo-reverse.svg";
import cyberreason from "../assets/sponsors/cyberreason-logo.png";
import threatray from "../assets/sponsors/threatray-logo.png";

import speaker_daniel_kuenzli from "../assets/speakers/daniel-kuenzli.png";
import speaker_thomas_cueni from "../assets/speakers/thomas-cueni.jpg";
import speaker_rene_bodmer from "../assets/speakers/rene-bodmer.png";
import speaker_luca_bertolotto_cipriani from "../assets/speakers/luca-bertolotto.png";
import speaker_fabian_gentinetta from "../assets/speakers/fabian_gentinetta.jpeg";
import speaker_martin_de_jongh from "../assets/speakers/MartinDJ_SentinelOne.png";
import speaker_eric_de_bressing from "../assets/speakers/eric-de-bressing.jpeg";
import speaker_patrick_buchholz from "../assets/speakers/patrick-buchholz.jpg";
import speaker_detlev_narr from "../assets/speakers/detlev-narr.png";
*/
import speaker_unknown from "../assets/speakers/unknown_person.jpg";


const eventDate: Date = new Date(2026, 4, 19, 12, 45); // 19 may 2026

export default function LuxEventTab() {
  return (
    <div className="container">
      <ThankYouNote />
      <section>
        <div style={styles.logoContainer}>
          <Logo width="auto" height="102px" />
        </div>
        <EventDate date={eventDate} />
        <Hero
          title="Lux’Hack"
          subtitle="Taking cybersecurity seriously, but not ourselves<br><br>A keynote presentation with inspiring insights from the perspective of a well-known CISO, exciting input presentations, and good networking opportunities await you. Aimed at Cybersecurity Experts, IT enthusiasts and Students with a Networking Apero in the evening"
          titleStyle={styles.title}
          subtitleStyle={styles.subtitle}
        />
        <div className="specs-container">
          <Spec icon={<DroppedPinIcon />} title="Big Bang, House of Startups" url="https://maps.app.goo.gl/P9bAGfjEs1v4FbPX6"/>
          <Spec icon={<FreeIcon />} title="100% Free" />
          <Spec icon={<ShieldElectricIcon />} title="100% cybersecurity" />
        </div>
        <EventCountdown date={eventDate} />
      </section>
      <section>
        <ButtonLink
          href="https://infomaniak.events/en-ch/shop/hack-event-2026-7JXWQVQSMG/event/1594598/"
          newTab={false}
          style={{ maxWidth: "161px" }}
        >
          Register
        </ButtonLink>
      </section>
      {/*
      <section>
        <AboutTheEvent mapUrl="./palexpo-plan.pdf"/>
      </section>
      */}
      {/*
      <section>
        <EventFormat imageSrc={eventFormatPhoto}/>
      </section>
      */}
      {
      <section>
        <Agenda
          headers={['', '']}
          agenda={[
            { time: "12:45 - 13:15", description1: "Registration and Welcome Coffee" },
            { time: "13:15 - 13:45", description1: "Opening Ceremony" },
            { time: "13:45 - 14:15", description1: "Keynote Speech,  Beyond Cybersecurity [Marcel Zumbühl, CISO of Swiss Post]" },
            { time: "14:15 - 14:45", description1: "AI in the Hackers' loop [Guillaume Vassault-Houlière, CEO & co-founder, YesWeHack]" },
            { time: "14:45 - 15:15", description1: "Presentation from Main Sponsor Harfanglab" },
            { time: "15:15 - 15:40", description1: "Networking Break" },
            { time: "15:40 - 17:30", description1: "Technical Presentations<ul><li>Supply Chain in a ZIP: The forgotten file that compromised everyone<br>[Ralph El Khoury, Senior Offensive Security Engineer, Swiss Post Cybersecurity]</li><li>From Detection to Crisis Management: A real SOC & CSIRT story<br>[Antony Ancelin, Technical lead incident response and Greg Divorne, Director of CSIRT, Swiss Post Cybersecurity]</li><li>Physical Intrusion: Field notes from the other side of the door<br>[Nicolas Aunay, Senior Offensive Security Engineer and Nicolas Boust, Offensive Security Engineer, Swiss Post Cybersecurity]</li><li>Detection is now a board-level responsibility - what NIS2 and DORA actually require from your SOC<br>[Vectra AI]</li>" },
            { time: "17:30", description1: "Apero and Networking" }
          ]
          }
        ></Agenda>
      </section>
      }
      {/*
      <section>
        {
        <PlanningSection
          title="Details"
          subtitle=""
          displayGrid="grid"
          planning={[
            {
              time: "13:00",
              title: "",
              description: "<h1>Registration & Welcome coffee</h1>",
              index: 0,
            },
            {
              time: "13:30",
              title: "",
              description: "<h1>Welcoming introduction</h1>",
              index: 0,
            },
            {
              time: "",
              title: "Tabletop Exercises: Because real Chaos has no pause button<br><small>Swiss Post Cybersecurity - Greg Divorne </small>",
              description: "We’ll break down the real value of cybersecurity table-tops — no simulations, just sharp insights, common pitfalls, and how to make chaos a little more manageable.",
              index: 1,
            },
            {
              time: "",
              title: "OT Security: Tips & Tricks<br><small>Swiss Post Cybersecurity - Christian Fichera & Raphael Ruf</small>",
              description: "OT and IT are different in many ways, and cybersecurity is certainly one of them. Priorities, vulnerabilities and how to remediate them are all key differences between these two worlds.<br>As a pentester, the way you approach assessing IT and OT environments needs to be different too, and the specific knowledge a tester has in the OT world can make the difference between a successful test and a broken OT device.<br>A demo taken from real life pentesting experience will also show how easy it can be to compromise OT environments.",
              index: 2,
            },
            {
              time: "",
              title: "Goodbye Purple Team, Hello Purple Bots<br><small>Hacknowledge Lux - Patrick Mkhael & Ralph El-Khoury</small>",
              description: "This talk unveils a fully automated, AI-driven purple teaming framework that simulates real-world APT attacks, evaluates detection capabilities, and enhances security defense, all in real-time.",
              index: 3,
            },
            {
              time: "",
              title: "From Pentest to Real Threat: Understanding Threat-Led Penetration Testing (TLPT) <br><small>Hacknowledge Lux - François-Jérôme Daniel</small>",
              description: "Traditional penetration testing often focuses on identifying technical vulnerabilities within a defined scope and time. While valuable, these tests rarely reflect how a real threat actor would target your organization. Threat-Led Penetration Testing (TLPT), on the other hand, is designed to simulate real-world, intelligence-driven attacks, tailored to your sector, critical assets, and threat landscape.",
              index: 4,
            },
            {
              time: "",
              title: "Threat Hunting Basics<br><small>Swiss Post Cybersecurity - Edin Mujkanovic</small>",
              description: "From Intel to Hunts. Threat hunting isn’t new but this session is a practical reminder of the basics. Learn how to use threat intelligence to build hunting hypotheses, assess visibility gaps, and take action when signs of compromise are foundWe will also discuss common challenges MSSPs face when handling CTI and provide a practical example of using CTI use case.",
              index: 5,
            },
            {
              time: "",
              title: "GRC tooling: evolution to AI-tomation<br><small>Hacknowledge Lux - Jean-Didier Zotna</small>",
              description: "Governance, Risk and Compliance Services (GRCS) play more than ever a crucial role in the risk management and regulatory compliance of companies. With the emergence and multiplication of local and international obligations and the constant rationalization of the resources dedicated to it, expectations and challenges keep increasing and related tools must evolve. Indeed, GRCS providers and pure players are organizing and proposing an adaptation of their solutions that incorporate automation and AI. Hacknowledge Lux here offers you a brief vision of this evolution and its new integrated hybrid service offering.",
              index: 6,
            },
            {
              time: "17:00",
              title: "",
              description: "<h1>Apero and Networking</h1>",
              index: 16,
            }
          ]}
        />
        }

      </section>
      */}
      {
      <section>
        <SpeakerSection
          title=""
          subtitle="Attendees will leave feeling more connected to a community of builders and to the future of the evolving world of cybersecurity"
          speakers={[
            {
              firstName: "Marcel",
              lastName: "Zumbühl",
              role: "CISO of Swiss Post",
              title: "Beyond Cybersecurity",
              description:
                "Cybersecurity today is shaped by speed, digital trust and human behavior rather than by technology alone. This talk explores how resilience, participation and culture turn people into the strongest link in an ever‑changing story centered around customers.",
              image:
                speaker_marcel_zumbuehl,
            },
            {
              firstName: "Sander",
              lastName: "Hofman",
              role: "Solution Engineer, HarfangLab",
              title: "Defending against legitimate tools. How to protect yourself when attackers reuse your own tools?",
              description:
                "8 out of 10 attacks no longer use malware. Attackers, whether ransomware operators or state-sponsored groups, now leverage your own administration tools to conduct their operations. PowerShell to execute code in memory, PsExec to deploy ransomware across an entire fleet... No malicious file, no signature to detect: this is the principle of Living-off-the-Land. It was recently discovered that the Chinese group Volt Typhoon had maintained stealthy access for several years within American critical infrastructure, using nothing but native system tools. On the ransomware side, groups like BlackCat or Black Basta systematically rely on these same techniques to bypass existing security solutions. How do you detect what appears legitimate but is actually malicious? Which signals should you prioritize monitoring?  This presentation aims to shed light on the mechanisms behind Living-off-the-Land and fileless attacks through concrete cases, and to propose best practices to regain the upper hand.",
              image:
                speaker_sander_hofman,
            },
            {
              firstName: "Guillaume",
              lastName: "Vassault-Houlière",
              role: "CEO & co-founder, YesWeHack",
              title: 
                "AI in the Hackers' loop",
              description:
                "In the era of AI and a booming cybersecurity market, we are witnessing a massive marketing blitz promising that artificial intelligence will revolutionize cyber defense and more particularly, vulnerability research. However, beyond the commercial rhetoric that has yet to be fully challenged, the impact of AI on the systems we defend is very real: vulnerabilities are being exploited faster and on an unprecedented scale. Cyber threats are becoming increasingly industrialized, and advanced technical skills are no longer a prerequisite for launching an automated attack against a company. But is this a true revolution? The constant arms race between attackers and defenders is what has shaped the evolution of cybersecurity from the beginning. In hacking, as in engineering, tooling and automation are indispensable steps in the search for vulnerabilities. While the arsenal is expanding, the best hackers will remain, as they always have been, master craftsmen, but equipped with tools they have mastered to perfection. Hacking is an art. The hacker is the artisan, capable of creating, building, reimagining, and diverting with the tools of their time. Human expertise remains essential to contextualize attacks and, above all, to innovate in a field where creativity prevails over simple execution.",
              image:
              speaker_guillaume_vassault,
            },
            {
              firstName: "Ralph",
              lastName: "El Khoury",
              role: "Senior Offensive Security Engineer, Swiss Post Cybersecurity",
              title: 
                "Supply Chain in a ZIP: The Forgotten File That Compromised Everyone",
              description:
                "One file. One vulnerability. Hundreds of organizations compromised. This talk presents a real-world supply chain attack that began with a single discovery: an unauthenticated ZIP file (DELETE_ME.zip) exposed in the directory of an ERP web application. Inside: the application's complete source code. Our analysis uncovered a critical unauthenticated RCE zero-day, plus JAR files containing hardcoded credentials for Azure Blob Storage, AWS, and Power BI. We'll walk through the full kill chain: exploiting the zero-day RCE to compromise the initial client, then realizing the same vulnerability existed in every deployed instance, meaning every organization running this ERP software was equally exploitable. But it didn't stop there. The hardcoded cloud credentials extracted from the JAR files gave us direct access to the ERP provider's cloud infrastructure: customer data backups, business intelligence dashboards, and production environments across Azure and AWS. A forgotten ZIP file turned a single client engagement into a supply chain catastrophe, one vulnerability to rule them all. Attendees will learn how small oversights cascade into massive breaches, how to identify hardcoded secrets in compiled artifacts, and what defensive measures could have stopped this attack at every stage.",
              image:
              speaker_ralph_el_khoury,
            },
            {
              firstName: "Antony",
              lastName: "Ancelin",
              role: "Technical lead incident response, Swiss Post Cybersecurity",
              title: 
                "From Detection to Crisis Management: A Real SOC & CSIRT Story",
              description:
                "SPCS will present a real incident that occurred a few weeks ago to demonstrate the practical value of a SOC and a CSIRT. The presentation will cover the full timeline, from the initial SOC detection to the CSIRT investigation and the infrastructure recovery. Beyond the technical investigation, the incident required around-the-clock response, coordination between multiple teams, and crisis management support. This case illustrates that when security tools such as AV or EDR are bypassed, detection, response, coordination, and crisis management become critical to successfully handle the incident.",
              image:
              speaker_antony_ancelin,
            },
            {
              firstName: "Nicolas",
              lastName: "Aunay",
              role: "Senior Offensive Security Engineer, Swiss Post Cybersecurity",
              title: 
                "Physical Intrusion: Field Notes from the Other Side of the Door",
              description:
                "This talk presents concrete feedback from physical pentest missions conducted across varied environments: datacenters, corporate headquarters, industrial sites, and sensitive facilities. Through anonymized real-world cases, we explore the most effective intrusion vectors, systemic failures in security controls, and the social psychology that makes these attacks possible.",
              image:
              speaker_nicolas_aunay,
            },
            {
              firstName: "",
              lastName: "",
              role: "Vectra AI",
              title: 
                "Detection is now a board-level responsibility — what NIS2 and DORA actually require from your SOC",
              description:
                "NIS2 and DORA have shifted the conversation from \"do we have a firewall\" to \"can we detect and contain an active attacker.\" For many Swiss and European organisations, the answer is uncomfortable: existing SOC services built around endpoint detection and log correlation were designed for a threat model that no longer reflects reality. In this session, our strategic partner Vectra AI walks through what regulators and national cyber authorities now expect, why prevention-only strategies no longer meet duty-of-care standards, and how advanced detection services help customers close the gap — with concrete examples from regulated industries in Switzerland and Europe.",
              image:
              speaker_unknown,
            }
          ]}
        />
      </section>
      }
      {
      <Sponsors
        style={{ marginTop: "120px" }}
        logos={[
          [harfanglab_logo],
          [elastic_logo, tenable_logo, vectra_logo],
          [ywh_logo]
        ]}
      />
      }
      <section>
        
        <Organizers
          organizers={[
            { src: post_logo, name: "Swiss Post Cybersecurity" }
          ]}
          is_luxembourg={true}
          post_logo={post_logo}
        />
        {/*post_logo*/}
      </section>
{       <ImageCarousel
        images={[
          eventFormatPhoto,
          "/img/21efdf712cf79fbd148856011f58bc6e.jpeg",
          "/img/2205cda10dfebc8d1ca3a5bbf2f8515e.jpeg",
          "/img/a7dc9838a6d79336be95edcbb10943c9.jpeg",
          "/img/c67f653b353385bcc7e424359aa6b3e8.jpeg",
          "/img/d6b45f79c4a62172598e9531d0587924.jpeg"
        ]}
        borderRadius="20px"
        height="284px"
        width="90%"
      /> }
      <section>
        <VideoSection
          video="https://maps.app.goo.gl/P9bAGfjEs1v4FbPX6"
          title="Lux'Hack"
          registerUrl="https://infomaniak.events/en-ch/shop/hack-event-2026-7JXWQVQSMG/event/1594598"
          image={video_image}
        />
      </section>
    </div>
  );
}

const styles = {
  logoContainer: {
    display: "flex",
    justifyContent: "center",
  },
  title: {
    background: "linear-gradient(90deg, #FFF 27.78%, #E1E1E1 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontFamily: "Poppins",
    fontSize: `${window.outerWidth < 768 ? "12vw" : "5vw"}`,
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
    margin: 0,
  },
  subtitle: {
    fontFamily: "Arvo",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    marginTop: "-18px",
    textAlign: "center" as "center",
  },
};
